import React, { useEffect } from 'react'

import { ThemeContextType, Theme } from '../types/theme'
import { ThemeContext } from '../contexts/ThemeContext'
// import { ThemeToggle } from '../components/ThemeToggle'

export const ThemeWrapper = ({ children }: { children: React.ReactNode }) => {
  const { theme, changeTheme } = React.useContext(
    ThemeContext,
  ) as ThemeContextType

  const setBodyClass = (theme: Theme, newTheme: string) => {
    if (typeof document !== 'undefined') {
      if (document.body.classList.contains(theme)) {
        document.body.classList.replace(theme, newTheme)
      } else {
        document.body.classList.add(newTheme)
      }
    }
  }

  const handleThemeChange = () => {
    let newTheme = 'light'

    if (theme === 'light') {
      newTheme = 'dark'
    }

    setBodyClass(theme, newTheme)
    changeTheme(newTheme as Theme)
  }

  const setThemeMode = (theme: ThemeContextType['theme']) => {
    setBodyClass(theme, theme)
    changeTheme(theme)
  }

  useEffect(() => {
    setThemeMode('light')
  }, [])

  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      {/* <ThemeToggle theme={theme} onChange={() => handleThemeChange()} /> */}

      {children}
    </div>
  )
}
